<template>
  <div>
    <div v-if="hasMoreThanThreeSchedules">
      <div v-for="(schedule) in firstThreeSchedules" :key="schedule.id || schedule.name">
        <ScheduleDetails
          :schedule="schedule"
        />
      </div>
      <div class="text-center" v-if="!shouldShowAllSchedules">
        <a @click.prevent="showAllSchedules">
          Show more schedules ({{schedules.length}}) <span class="fal fa-angle-down"></span>
        </a>
      </div>
      <div v-if="shouldShowAllSchedules">
        <div v-for="(schedule) in remainingSchedules" :key="schedule.id || schedule.name">
          <ScheduleDetails
            :schedule="schedule"
          />
        </div>
        <div class="text-center">
          <a @click.prevent="showFewerSchedules">
            Show fewer schedules <span class="fal fa-angle-up"></span>
          </a>
        </div>
      </div>
    </div>
    <div v-for="(schedule) in allSchedules" :key="schedule.id || schedule.name" v-else>
      <ScheduleDetails
        :schedule="schedule"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import ScheduleDetails from './schedule-details.vue';

const props = defineProps({
  schedules: {
    type: Array,
    required: true,
  },
});

const shouldShowAllSchedules = ref(false);
const allSchedules = computed(() => [...props.schedules]
  .filter((schedule) => schedule.variations && schedule.variations.length > 0)
  .sort((a, b) => {
    if (b.seatsCount !== a.seatsCount) {
      return b.seatsCount - a.seatsCount;
    }
    if (b.daysPerWeek !== a.daysPerWeek) {
      return (b.daysPerWeek || 0) - (a.daysPerWeek || 0);
    }
    return a.name.localeCompare(b.name);
  }));
const firstThreeSchedules = computed(() => allSchedules.value.slice(0, 3));
const remainingSchedules = computed(() => allSchedules.value.slice(3));
const hasMoreThanThreeSchedules = computed(() => allSchedules.value.length > 3);

const showAllSchedules = () => {
  shouldShowAllSchedules.value = true;
};

const showFewerSchedules = () => {
  shouldShowAllSchedules.value = false;
};
</script>

<style scoped>
a {
  color: var(--sapphire-500) !important;
  font-weight: 400;
  font-size: 16px;
  transition: color 0.2s ease;
  cursor: pointer;
}

a:hover {
  color: var(--teal-60);
  text-decoration: none;
}

.fal {
  margin-left: 4px;
}
</style>
